import { V5_AUDIENCE } from '../../access';

// Signed out, so the admin-only gate in V5Layout cannot protect it: the route exists only once the
// redesign is for everyone. routes.js marks every page auth: true; vue-auth reads the deepest
// matched record, so the child's auth: false (signed-out only, as the classic /register) wins.
export default V5_AUDIENCE === 'all' ? [{
  path: '/v5/register',
  meta: { bare: true },
  children: [{
    path: '', name: 'V5_register', component: () => import('./RegisterPage.vue'), meta: { auth: false },
  }],
}] : [];
